// Sound effects using Howler.js
import { Howl } from 'howler';
import { loadSettings } from '../storage/settings';

interface SoundMap {
  [key: string]: Howl;
}

let sounds: SoundMap = {};
let initialized = false;

export function initSounds(): void {
  if (initialized) return;

  sounds = {
    move: new Howl({ src: ['/sounds/move.mp3'], volume: 0.5 }),
    capture: new Howl({ src: ['/sounds/capture.mp3'], volume: 0.6 }),
    check: new Howl({ src: ['/sounds/check.mp3'], volume: 0.7 }),
    castle: new Howl({ src: ['/sounds/castle.mp3'], volume: 0.5 }),
    promote: new Howl({ src: ['/sounds/promote.mp3'], volume: 0.6 }),
    gameover: new Howl({ src: ['/sounds/gameover.mp3'], volume: 0.7 }),
    achievement: new Howl({ src: ['/sounds/achievement.mp3'], volume: 0.8 }),
  };

  initialized = true;
}

export type SoundName = keyof typeof sounds extends never ? string : 'move' | 'capture' | 'check' | 'castle' | 'promote' | 'gameover' | 'achievement';

export function playSound(name: SoundName): void {
  const settings = loadSettings();
  if (!settings.soundEnabled) return;
  if (!initialized) initSounds();

  const sound = sounds[name];
  if (sound) {
    sound.play();
  }
}
